export default __webpack_public_path__ + "images/0xc97d74d05eff009027bee8514c310a0b1e2d1c3c.png";